import React from 'react'
import styled from 'styled-components'

import { ColumnFlexCentered } from '~/components/common/containers'
import { MAX_MOBILE_THRESHOLD } from '~/core/constants'
import { translate } from '~/core/translate'
import { BodyShort02, buttonMediumCss } from '../typography'

const ViewButton = styled.span`
  ${buttonMediumCss}
  color: #1B67EC;
  padding: 8px 16px;
  margin-top: 16px;
  cursor: pointer;
`

const Container = styled(ColumnFlexCentered)`
  background-color: #E7EAEE;
  border-radius: 8px;
  box-sizing: border-box;
  margin: 24px;
  padding: 24px 24px 32px;
  text-align: center;
  width: calc(100% - 48px);

  @media screen and (min-width: ${MAX_MOBILE_THRESHOLD}) {
    width: 640px;
  }
`

const ViewUpgradeOptions = ({ onViewUpgrade }) => (
  <Container>
    <BodyShort02>{translate('more_users_2')}</BodyShort02>
    <ViewButton onClick={onViewUpgrade}>
      {translate('view_upgrade_options')}
    </ViewButton>
  </Container>
)

export default ViewUpgradeOptions
